import React, { useEffect, useState } from "react";
import { Table, Tag, Space, Button, Select, Modal, notification } from "antd";

import {
  viewModulesActionList,
  deleteModuleAction,
} from "../../redux/actions/courseActions";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  DeleteFilled,
  ExclamationCircleOutlined,
  EditFilled,EyeFilled
} from "@ant-design/icons";

const ModuleManagement = ({
  viewModulesActionList,
  deleteModuleAction,
  deletedModule,
  moduleState,
  match,
}) => {
  const [isLoading, setLoader] = useState(true);
  const { confirm } = Modal;

  const courseName = match.params.courseName;
  const getAllModules = () => {
    viewModulesActionList(courseName);
  };
  useEffect(() => {
    getAllModules();
    if (moduleState.allCoursesData) {
      setLoader(false);
    }
    if (deletedModule.deletedModuleData) {
      notification.success({ message: "Module deleted successfully" });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
    if (deletedModule.deletedModuleError) {
      notification.error({
        message: "Unable to delete module. Please try again.",
      });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }, [deletedModule]);

  const showDelete = (courseName, moduleName) => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure you want to delete "${moduleName}"?`,
      onOk() {
        deleteModuleAction({ courseName, moduleName });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const modules = moduleState.allModulesData?.data.map((mod, index) => {


 
     const tags = mod.tags?.split(",") || ["N/A"];
    const resources = mod.resources || "N/A";
    return {
      name: mod.name,
      description: mod.description,
      tags,
      week:mod.week,
      date: mod.createdAt,
      creator: mod.user.firstName,
      key: index,
    };

    
  });

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, module) => {
        return (
          <Link
            to={{
              pathname: `/dashboard/courses/${courseName}/edit-module`,
              data: module, // your data array of objects
            }}
          >
            {text}
          </Link>
        );
      },
    },
    {
      title: "Week",
      dataIndex: "week",
      key: "week",
    },
    {
      title: "Tags",
      key: "tags",
      dataIndex: "tags",
      render: (tags) => (
        <>
          {tags.map((tag) => {
            let color = tag.length > 5 ? "geekblue" : "green";
            if (tag === "N/A") {
              color = "volcano";
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: "Creator",
      dataIndex: "creator",
      key: "creator",
    },
    {
      title: "Date created",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          <Space size="middle">
            <Link
            to={{
              pathname: `/dashboard/courses/${courseName}/module-management`,
              data: record, // your data array of objects
            }}
            >
              <DeleteFilled
                onClick={() => showDelete(courseName, record.name)}
              />
            </Link>
              <Link
                to={{
                  pathname: `/dashboard/courses/${courseName}/module-management`,
                  data: record, // your data array of objects
                }}
              >
                < EditFilled/>
              </Link>
              <EyeFilled key="view"/>
          </Space>
        );
      },
    },
  ];

  return (
    <>
      <Space style={{ marginBottom: 16 }}>
        <Link to={`/dashboard/courses/${courseName}/new-module?week=${4}`}>
          <Button
            type="primary"
            size="large"
            // className="container-100"
            htmlType="submit"
          >
            New module
          </Button>
        </Link>
      </Space>
      <Table
        title={() => <h2>{courseName} Modules</h2>}
        columns={columns}
        dataSource={modules}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    moduleState: state.courses.allModules,
    deletedModule: state.courses.deleteModule,
  };
};

export default connect(mapStateToProps, {
  viewModulesActionList,
  deleteModuleAction,
})(ModuleManagement);
